module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    ref: "select",
    class: ( _obj = {}, _obj[_vm.additionalClasses] = true, _obj ),
    attrs: {
      "name": "test"
    },
    on: {
      "change": function($event) {
        return _vm.selectChanged()
      }
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('option', {
      key: item[_vm.valueKey],
      domProps: {
        "value": item[_vm.valueKey]
      }
    }, [_vm._v(_vm._s(item[_vm.nameKey]))])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d114d87e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d114d87e!./~/vue-loader/lib/selector.js?type=template&index=0!./www/local/vue.js/v-selectric/v-selectric.vue
// module id = 15
// module chunks = 0